import { observer } from 'mobx-react';
import { PropsWithChildren, useRef } from 'react';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import ExperienceVideoDetails from './ExperienceVideoDetails';
import { useVisibilityObserver } from './useVisibilityObserver';

interface Props {
  className?: string;
  experienceResource: ExperienceDictionaryEntryResponse;
}

function ExperienceVideoState({
  className,
  children,
  experienceResource,
}: PropsWithChildren<Props>) {
  const placeholderRef = useRef<HTMLDivElement>(null);
  const hasBeenVisible = useVisibilityObserver(placeholderRef);

  return experienceResource.links.thumbnail
    .map((link) =>
      hasBeenVisible ? (
        <ExperienceVideoDetails
          className={className}
          title={experienceResource.payload.title.text}
          thumbnail={link.href}
          experienceResource={experienceResource}
        />
      ) : (
        <div ref={placeholderRef} className={className} />
      ),
    )
    .getOrElse(() => <>{children}</>);
}

export default observer(ExperienceVideoState);
